import { useState } from 'react'

import { EMPTY_STRING } from '../../../constants/common'
import { CurrencySelect } from '../../Currency'
import { Component, ComponentProps } from '../Component'
import { boolean, controls, json, text } from '../Controls'

import { MOCK_CURRENCY_OPTIONS } from './CurrencySelectUsage.constants'

export function CurrencySelectUsage() {
  const [props, setProps] = useState(() =>
    controls() //
      .add(json('currencyOptions', MOCK_CURRENCY_OPTIONS))
      .add(boolean('disabled', false))
      .add(text('error', EMPTY_STRING))
      .add(json('value', { amount: '2000000.00', currency: 'EUR' }))
  )

  function handleChange(nextValue) {
    setProps(currProps => currProps.setValue('value', nextValue))
  }

  return (
    <>
      <Component
        {...props.getValues()}
        Component={CurrencySelect}
        name='CurrencySelect'
        onChange={handleChange}
      />
      <ComponentProps name='CurrencySelect' value={props} onChange={setProps} />
    </>
  )
}
